package fr.arcplex.network.http

/**
 * Provides enumerated HTTP verbs
 */
enum class RequestMethod {
    GET, DELETE, HEAD, OPTIONS, PATCH, POST, PUT
}